import { BlogSection } from "@/types/blog";

export const fazit: BlogSection = {
  id: "fazit",
  title: "Fazit",
  content: `
    <p>Gute Führung wirkt leise.</p>

    <p>Sie zeigt sich in Aufmerksamkeit, Klarheit und Respekt.</p>

    <p>Weniger Methoden. Mehr Haltung.<br/>
    Weniger Kontrolle. Mehr Beziehung.</p>

    <p><strong>Wer sich selbst führen kann, kann andere führen.<br/>
    Alles andere sind Werkzeuge.</strong></p>

    <h3>Thematische Vertiefung & Angebote</h3>
    <ul>
      <li><a href="/blog/souveraenitaet-komplexitaet-katalysator-methode" rel="noopener">Souveränität in der Komplexität: Warum Wissen allein oft nicht zur Entscheidung führt</a></li>
      <li><a href="/blog/hochsensible-fuehrung" rel="noopener">Führung als hochsensibler Mensch: Warum feine Wahrnehmung wertvoll sein kann</a></li>
      <li><a href="/executive-coaching" rel="noopener">Executive Coaching – Begleitung für Führungskräfte</a></li>
    </ul>
  `
};
